/**
 * Formats bytes into human-readable string (KB, MB, GB, etc.)
 */
export function formatBytes(bytes?: number): string {
	if (!bytes) return '0 Bytes';
	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return (bytes / Math.pow(k, i)).toFixed(0) + sizes[i];
}
